import { Colors } from '../consts/Colors';
import RoundedButton from './RoundedButton';
import RoundedButtonReverted from './RoundedButtonReverted';
import {isMobile} from '../sydo/utils/IsMobile'

export default class EndBoard extends Phaser.GameObjects.Container {
    constructor(scene, score) {
        super(scene, 390, 779, []);

        scene.add.existing(this);
        this.scene = scene;
        this.score = score;

        this.back = this.scene.add.rectangle(0, 0, 1514, 284, Colors.Elmt.DarkBlue, 1).setOrigin(0);
        this.add(this.back);

        this.scoreBox = this.scene.add.rexRoundRectangle(21, 32, 345, 192, 22, Colors.Elmt.Beige).setOrigin(0)
        this.add(this.scoreBox);

        this.goodBox = this.scene.add.image(52, 62, 'goodBox').setOrigin(0)
        this.add(this.goodBox);

        this.goodText = this.scene.add.text(205, 90, "BRAVO", {
            font: "24px MassiliaExtraBold",
            color: Colors.Text.Green
        }).setOrigin(0, 0.5)
        this.add(this.goodText);

        this.goodScore = this.scene.add.text(135, 90, this.score.bravo, {
            font: "32px MassiliaExtraBold",
            color: Colors.Text.White
        }).setOrigin(0.5)
        this.add(this.goodScore);

        this.badBox = this.scene.add.image(52, 140, 'badBox').setOrigin(0)
        this.add(this.badBox);
        let ctnt = ""
        if (this.score.mauvais > 1) {
            ctnt = "MAUVAISES\nRÉPONSES"
        } else if (this.score.mauvais <= 1) {
            ctnt = "MAUVAISE\nRÉPONSE"
        }

        this.badText = this.scene.add.text(205, 166, ctnt, {
            font: "24px MassiliaExtraBold",
            color: Colors.Text.Red
        }).setOrigin(0, 0.5)
        this.add(this.badText);

        this.badNum = this.scene.add.text(135, 166, this.score.mauvais, {
            font: "32px MassiliaExtraBold",
            color: Colors.Text.White
        }).setOrigin(0.5)
        this.add(this.badNum);




        var isTrue = false
        var videoReplay = false
        var txtTitre = "Félicitations !"
        // var txt = "Les Les tribunaux de commerce n’ont plus aucun secret pour vous !\n\nIl est temps de découvrir la vidéo suivante : XXXXXX XXXXXX XXXXX"
        var txt = "Les mesures de prévention et de traitement de difficultés des entreprises n'ont plus de secret pour vous ! Il est temps de découvrir d'autres quiz."
        if ((this.score.mauvais) <= 9 && (this.score.mauvais) >= 5) {
            txtTitre = "C'est un bon début !"
            txt = "Rejouez avant de découvrir d'autres quiz !"
            // txt = "Rejouez avant de regarder la vidéo suivante sur ******** !"
        } else if ((this.score.mauvais) >= 10) {
            txtTitre = "Vous pouvez faire mieux !"
            txt = "Regardez de nouveau la vidéo et rejouez !"
            videoReplay = true
        } else {
            isTrue = true
        }

        this.title = this.scene.add.text(398, 62, txtTitre, {
            font: "40px MassiliaExtraBold",
            color: Colors.Text.White
        }).setOrigin(0, 0.5)
        this.add(this.title);

        this.content = this.scene.add.text(398, 105, txt, {
            font: "24px MassiliaRegular",
            color: Colors.Text.White,
            align: "left",
            lineSpacing: 8,
            wordWrap: { width: 575, useAdvancedWrap: true }
        }).setOrigin(0)
        this.add(this.content);


        var boutonVideo = undefined
        var boutonRejouer = undefined

        let boutonLinkedin = new RoundedButtonReverted(this.scene, 1035 + 300 / 2, 40 + 52 / 2, 300, 52, "   Partager", Colors.Text.White, Colors.Elmt.DarkBlue, 26)
        // boutonLinkedin = new RoundedButton(this.scene, 1035 + 382 / 2, 40 + 52 / 2, 382, 52, "Découvrir la vidéo suivante", Colors.Text.DarkBlue, Colors.Elmt.DarkBlue, 26)
        this.add(boutonLinkedin);
        let icon = this.scene.add.image(-boutonLinkedin.textButton.width/2, 0, 'logoLinkedin').setOrigin(1, 0.5)
        boutonLinkedin.add(icon)
        boutonLinkedin.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
        boutonLinkedin.setTextSize("28px")
        boutonLinkedin.on('pointerover', () => {icon.setTint(Colors.Elmt.DarkBlue)})
        boutonLinkedin.on('pointerout', () => {icon.setTint(Colors.Elmt.White)})
        boutonLinkedin.setClickFunction(() => {
            const text = "&text=%E2%9C%85+D%C3%A9fi+pr%C3%A9vention+et+traitement+des+difficult%C3%A9s+%3A+r%C3%A9ussi+%21%0D%0AJe+viens+de+tester+mes+connaissances+avec+un+quiz+propos%C3%A9+par+la+Banque+de+France+%E2%80%93+EDUCFI.%0D%0A%F0%9F%8E%AF+Verdict+%3A+mission+accomplie%E2%80%A6+et%2C+surtout%2C+des+rep%C3%A8res+plus+clairs+sur+le+r%C3%B4le+des+tribunaux+de+commerce+et+les+dispositifs+pour+pr%C3%A9venir+et+traiter+les+difficult%C3%A9s+des+entreprises.%0D%0AParce+qu%E2%80%99anticiper+et+comprendre+les+solutions+existantes+est+essentiel+pour+s%C3%A9curiser+son+activit%C3%A9%2C+ces+formats+ludiques+sont+une+excellente+mani%C3%A8re+de+se+former+autrement.%0D%0A%F0%9F%91%89+Et+vous%2C+pr%C3%AAt%28e%29s+%C3%A0+relever+le+d%C3%A9fi+%EF%BC%9F#overlay_share-modal"
            const url = "https://www.linkedin.com/shareArticle/?url=https%3A%2F%2Fwww.mesquestionsdentrepreneur.fr%2Fsites%2Fbdf_mqde%2Fuploads%2Ftribunaux-de-commerce-simple-comme-compta%2F"
            if(isMobile()){
                window.open(url, '_blank');
            }else{
                window.open(url + text, '_blank');
            }
            // window.open("https://youtu.be/l1nTs54zj7Q?si=a2zWX810A7j4whtg", '_blank');
        })

        if (!isTrue) {
            boutonRejouer = new RoundedButton(this.scene, 1035 + 144 / 2, 100 + 52 / 2, 144, 52, "Rejouer", Colors.Text.DarkBlue, Colors.Elmt.DarkBlue, 26)
            this.add(boutonRejouer);
            boutonRejouer.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
            boutonRejouer.setTextSize("28px")
            boutonRejouer.setClickFunction(() => {
                this.scene.game.data.cardNumber1 = 0
                this.scene.game.data.cardNumber2 = 0
                this.scene.game.data.score = {
                    bravo: 0,
                    presque: 0,
                    mauvais: 0
                }
                this.scene.scene.start("Menu")
            })

            boutonVideo = new RoundedButtonReverted(this.scene, 1035 + 342 / 2, 160 + 52 / 2, 342, 52, "Découvrir d'autres quiz", Colors.Text.White, Colors.Elmt.DarkBlue, 26)
            // boutonVideo = new RoundedButtonReverted(this.scene, 1035 + 382 / 2, 116 + 52 / 2, 382, 52, "Découvrir la vidéo suivante", Colors.Text.DarkBlue, Colors.Elmt.DarkBlue, 26)
            this.add(boutonVideo);
            boutonVideo.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
            boutonVideo.setTextSize("28px")
            boutonVideo.setClickFunction(() => {
                window.open("https://www.mesquestionsdentrepreneur.fr/espace-enseignants-accompagnateurs/quiz-interactifs", '_blank');
            })
              
        } else {
            

            boutonVideo = new RoundedButton(this.scene, 1035 + 342 / 2, 100 + 52 / 2, 342, 52, "Découvrir d'autres quiz", Colors.Text.DarkBlue, Colors.Elmt.DarkBlue, 26)
            // boutonVideo = new RoundedButton(this.scene, 1035 + 382 / 2, 40 + 52 / 2, 382, 52, "Découvrir la vidéo suivante", Colors.Text.DarkBlue, Colors.Elmt.DarkBlue, 26)
            this.add(boutonVideo);
            boutonVideo.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
            boutonVideo.setTextSize("28px")
            boutonVideo.setClickFunction(() => {
                window.open("https://www.mesquestionsdentrepreneur.fr/espace-enseignants-accompagnateurs/quiz-interactifs", '_blank');
            })

            boutonRejouer = new RoundedButtonReverted(this.scene, 1035 + 144 / 2, 160 + 52 / 2, 144, 52, "Rejouer", Colors.Text.White, Colors.Elmt.DarkBlue, 26)
            this.add(boutonRejouer);
            boutonRejouer.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
            boutonRejouer.setTextSize("28px")
            boutonRejouer.setClickFunction(() => {
                this.scene.game.data.cardNumber1 = 0
                this.scene.game.data.cardNumber2 = 0
                this.scene.game.data.score = {
                    bravo: 0,
                    presque: 0,
                    mauvais: 0
                }
                this.scene.scene.start('Game1')
            })
        }
            
              const boutonTerminer = new RoundedButtonReverted(this.scene, 1035 + 162 / 2, 220 + 52 / 2, 162, 52, "Terminer", Colors.Text.White, Colors.Elmt.DarkBlue, 26)
        this.add(boutonTerminer);
        boutonTerminer.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
        boutonTerminer.setTextSize("28px")
        boutonTerminer.setClickFunction(() => {
            // this.nextScene()
            this.scene.scene.start('Fin')
        })
        // const boutonTerminer = new RoundedButtonReverted(this.scene, 1035 + 162 / 2, 193 + 52 / 2, 162, 52, "Terminer", Colors.Text.White, Colors.Elmt.DarkBlue, 26)
        // this.add(boutonTerminer);
        // boutonTerminer.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
        // boutonTerminer.setTextSize("28px")
        // boutonTerminer.setClickFunction(() => {
        //     // this.nextScene()
        //     this.scene.scene.start('Fin')
        // })
    }

}